import { omit } from 'lodash-es';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  extends: 'Modal',
  name: 'FcModal',
  props: {
    // visible  和title 是 antd  基础组件自己的属性,不知道为啥再写一次
    // form配置项 包含form
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '标准弹框',
    },
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maskClosable: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {
    visible: {
      handler(newVal, oldVal) {
        if (newVal) this.$emit('loadData');
      },
    },
  },
  methods: {
    click(type, form, index) {
      this.$emit('click', type, form, index);
    },
    change(e, item, form, optionsFormIndex, forms) {
      this.$emit('change', e, item, form, optionsFormIndex, forms);
    },
    // 校验
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.handleSubmit().then(result => {
          if (result !== 'check error!') {
            resolve(result);
          } else {
            resolve('check error!');
          }
        });
      });
    },

    //
    setFormOpts(forms, field, options) {
      this.$nextTick(() => {
        this.$refs.form.setFormOpts(forms, field, options);
      });
    },
    //
    setFormsOpts(forms, field, value, index, options) {
      this.$nextTick(() => {
        this.$refs.form.setFormsOpts(forms, field, value, index, options);
      });
    },
  },
  render() {
    const { _props, $listeners, $slots, $scopedSlots, $attrs, forms, loading, maskClosable } = this;
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-modal');
    return (
      <a-modal
        class={prefixCls}
        {...{ props: omit($attrs, 'visible', 'title') }}
        {...{ on: $listeners }}
        {...{ scopedSlots: omit($scopedSlots, 'default') }}
        visible={this.visible}
        title={this.title}
        maskClosable={maskClosable}
      >
        {/* <perfect-scrollbar ref="scrollbar"> */}
        <div class="scrollBorder">
          <div class="scroll">
            {Object.keys(forms).length > 0 ? (
              <fc-form
                ref="form"
                labelAlign={$attrs['labelAlign'] || $attrs['label-align'] || 'right'}
                forms={forms}
                onClick={this.click}
                onChange={this.change}
              ></fc-form>
            ) : null}
            {$slots.content ? <div class="content">{$slots.content}</div> : null}
            {!!$slots.default ? <div class="content">{$slots.default}</div> : null}
          </div>
          {loading ? (
            <div class="example">
              <a-spin />
            </div>
          ) : null}
        </div>

        {/* </perfect-scrollbar> */}
      </a-modal>
    );
  },
};
